
import React from 'react';
import { TableCell, TableRow } from '@/components/ui/table';

const InstanceTableEmptyState: React.FC = () => {
  return (
    <TableRow>
      <TableCell colSpan={6} className="text-center py-8 text-muted-foreground">
        No instances found
      </TableCell>
    </TableRow>
  );
};

export default InstanceTableEmptyState;
